import { useState, useCallback, useRef } from "react";
import UserAtecoService from "../../../../../service/UserAtecoService";

export function useUserAtecoCodes() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const serviceRef = useRef(new UserAtecoService());

  const refresh = useCallback(async (token) => {
    if (!token) return;
    setLoading(true);
    try {
      const data = await serviceRef.current.getAtecoCodes(token);
      const items = Array.isArray(data) ? data : data?.result ?? data ?? [];
      setList(Array.isArray(items) ? items : []);
    } catch (err) {
      setList([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const assign = useCallback(async (token, payload) => {
    if (!token) return null;
    try {
      const result = await serviceRef.current.assignAtecoCode(token, payload);
      const added = result?.id != null ? result : Array.isArray(result) ? result : null;
      if (added) setList((prev) => (Array.isArray(added) ? [...prev, ...added] : [...prev, added]));
      return result;
    } catch (err) {
      throw err;
    }
  }, []);

  const remove = useCallback(async (token, atecoId) => {
    if (!token) return;
    await serviceRef.current.deleteAtecoCode(token, atecoId);
    setList((prev) => prev.filter((item) => item.id !== atecoId));
  }, []);

  return { list, loading, assign, remove, refresh };
}
